import { Link, useLocation } from 'react-router-dom';

import './sanctuary-site.css';

const PLAY_URL = 'https://play.google.com/store/apps/details?id=com.sahgal.sanctuaryy';
const SUPPORT_EMAIL = 'sanctuary.app.noreply@gmail.com';

export function SanctuaryFooter() {
  return (
    <footer className="sanc-footer">
      <div className="sanc-wrap sanc-footer__inner">
        <div className="sanc-footer__brand">
          <p className="sanc-footer__copy">© {new Date().getFullYear()} Uxpert Tech Solutions</p>
          <p className="sanc-footer__meta">Sanctuary · com.sahgal.sanctuaryy</p>
          <p className="sanc-footer__meta">Udyam: UDYAM-UP-04-0050998</p>
        </div>
        <nav className="sanc-footer__links" aria-label="Legal">
          <Link to="/projects/sanctuary/privacy">Privacy</Link>
          <Link to="/projects/sanctuary/terms">Terms</Link>
          <Link to="/projects/sanctuary/refund">Refund</Link>
          <Link to="/projects/sanctuary#contact">Contact</Link>
        </nav>
      </div>
    </footer>
  );
}

export function SanctuaryHeader() {
  const { pathname } = useLocation();
  const onHome = pathname === '/projects/sanctuary';

  return (
    <header className="sanc-header">
      <div className="sanc-wrap sanc-header__inner">
        <Link to="/projects/sanctuary" className="sanc-logo">
          Sanctuary
        </Link>
        <nav className="sanc-header__nav">
          {onHome ? (
            <>
              <a href="#screens">Tour</a>
              <a href="#features">Features</a>
              <a href="#pricing">Pricing</a>
              <a href="#contact">Contact</a>
            </>
          ) : (
            <Link to="/projects/sanctuary">Home</Link>
          )}
          <a
            className="sanc-btn sanc-btn--sm"
            href={PLAY_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Free trial
          </a>
        </nav>
      </div>
    </header>
  );
}

export function SanctuaryShell({ children }) {
  return (
    <div className="sanc-site">
      <SanctuaryHeader />
      {children}
      <SanctuaryFooter />
    </div>
  );
}

export const sanctuaryLinks = {
  play: PLAY_URL,
  email: SUPPORT_EMAIL,
  phone: '9305066213',
  phoneTel: 'tel:+919305066213',
  address:
    '39, Residential House, Chaturipatti (Dihwa), Bhiti Road, Akbarpur, Ambedkar Nagar, Uttar Pradesh 224141',
  business: 'Uxpert Tech Solutions',
  udyam: 'UDYAM-UP-04-0050998',
  privacyFull: 'https://sanctuary-privacy-v1.netlify.app/#s1',
};
